import {
    GA4EventName,
    trackEecToggleWishlistItem,
    trackToggleWishlist,
    type WishListEventType,
} from '@jsmdg/tracking';
import { ProductPromotionType, ProductPromotionTypeTrackingLabel } from '../../../shared/enums';
import { isBox, isExperience } from '../../../shared/product-safeguards';
import { type Price, type Product } from '../../../shared/types';
import { getPurchaseVariantForTracking } from '../../helper/getPurchaseType';
import { type PurchaseType } from '../../types/enums/purchaseType';

export async function trackToggleWishlistItemForEec(
    product: Product,
    price: Price,
    purchaseType: PurchaseType | undefined,
    isProductInWishlist: boolean,
): Promise<void> {
    await window.yieldToMainThread();
    trackEecToggleWishlistItem({
        product: {
            id: product.productId,
            url: product.url,
            trackingName: product.trackingName,
            manufacturerSku: product.manufacturerSku,
            trackingPath: product.trackingPath,
            price,
            originalPrice: product.originalPrice,
            title: product.title,
            rating: product.rating,
            ...(isExperience(product) || isBox(product)
                ? {
                      participants: {
                          min: product.minParticipants,
                          max: product.maxParticipants,
                      },
                  }
                : {}),
            ...(isExperience(product)
                ? {
                      locationCount: product.locations.length,
                  }
                : {}),
            nudge: product.productNudge
                ? {
                      id: product.productNudge?.id,
                      text: product.productNudge?.text,
                  }
                : undefined,
            discountBadgeId: product.discountBadge?.id,
            discountBadgeName: product.discountBadge?.text,
            promotion:
                product.promotionType !== ProductPromotionType.None
                    ? ProductPromotionTypeTrackingLabel[product.promotionType]
                    : undefined,
        },
        quantity: 1,
        variant: getPurchaseVariantForTracking(product.type, purchaseType),
        eventName: isProductInWishlist
            ? GA4EventName.RemoveFromWishlist
            : GA4EventName.AddToWishlist,
    });
}

export async function trackToggleWishlistItem(
    productId: string,
    trackingType: WishListEventType,
    title: string,
): Promise<void> {
    await window.yieldToMainThread();
    trackToggleWishlist({
        type: trackingType,
        productId,
        productTitle: title,
    });
}
